// import React from 'react'
// import step1 from './images/step1.png'
// import step2 from './images/step2.png'
// import step3 from './images/step3.png'
// export default function Step_uiux_design() {
//   return (
//     <>
//       <div className="container uiux-step-main">
//         <div className="row row-cols-3 uiux-step-row">
//             <div className="col uiux-step-col">
//                 <div className="uiux-step-img">
//                     <img src={step1} alt="" />
//                 </div>
//                 <div className="uiux-step-heading">
//                     <h2>RESEARCH</h2>
//                 </div>
//                 <div className="uiux-step-para">
//                     <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed 
// diam nonummy nibh euismod tincidunt ut laoreet dolore 
// magna aliquam erat volutpat.</p>
//                 </div>
//             </div>
//             <div className="col uiux-step-col">
//                 <div className="uiux-step-img">
//                     <img src={step2} alt="" />
//                 </div>
//                 <div className="uiux-step-heading">
//                     <h2>WIRE FRAME</h2>
//                 </div>
//                 <div className="uiux-step-para">
//                     <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed 
// diam nonummy nibh euismod tincidunt ut laoreet dolore 
// magna aliquam erat volutpat.</p>
//                 </div>
//             </div>
//             <div className="col uiux-step-col">
//                 <div className="uiux-step-img">
//                     <img src={step3} alt="" />
//                 </div>
//                 <div className="uiux-step-heading">
//                     <h2>WEBSITE DESIGN</h2>
//                 </div>
//                 <div className="uiux-step-para">
//                     <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed 
// diam nonummy nibh euismod tincidunt ut laoreet dolore 
// magna aliquam erat volutpat.</p>
//                 </div>
//             </div>
            

//         </div>

//       </div>
//     </>
//   )
// }

import React from 'react'

export default function MultiStepForm() {
  return (
    <>
      <div className="container main-steps">
        <div className="row row-cols-4 sub-main-steps">
          <div className="col step-cols">
            <h2>STEP 1</h2>
            <h3>
Discovery & Research
</h3>
            <p>We start by thoroughly understanding your business, audience, and industry to build a design strategy that perfectly aligns with your goals. Our discovery process includes:</p>
            <ul>
              <li>User research to grasp audience needs</li>
              <li>Market analysis to identify trends and opportunities</li>
              <li>Competitor benchmarking to find your unique edge</li>
              <li>Creation of detailed user personas for targeted design</li>
            </ul>
          </div>
          <div className="col step-cols">
          <h2>STEP 2</h2>
            <h3>Wireframing & Prototyping</h3>
            <p>In our UI UX design services, we develop detailed wireframes that outline user flows and interface components to create a smooth and intuitive experience. This stage involves:</p>
            <ul>
              <li>Mapping user journeys to visualize interaction paths</li>
              <li>Building interactive prototypes for real-time experience</li>
              <li>Conducting usability testing to identify improvements</li>
              <li>Integrating feedback to refine the design for optimal performance</li>
            </ul>
          </div>
          <div className="col step-cols">
          <h2>STEP 3</h2>
            <h3>Design</h3>
            <p>Our UI UX design services bring your brand to life through visually engaging designs that captivate your audience. Key elements include:</p>
            <ul>
              <li>Seamless brand integration to reflect your identity</li>
              <li>Thoughtful typography and color selection for impact</li>
              <li>High-fidelity mockups that showcase the final look</li>
              <li>Creation of comprehensive design systems for consistency</li>
              <li>Maintaining visual harmony across all interfaces</li>
            </ul>
            </div>
          <div className="col step-cols">
          <h2>STEP 4</h2>
            <h3>Evaluate</h3>
            <p>We thoroughly test and refine your design to ensure it exceeds user expectations and drives your business goals. Our evaluation process includes:</p>
            <ul>
              <li>Comprehensive usability testing to identify improvement areas</li>
              <li>A/B testing to compare design variations and optimize performance</li>
              <li>Continuous user feedback loops for real-world insights</li>
              <li>Iterative design enhancements based on data-driven results</li>
              <li>Final validation to guarantee a polished, effective solution</li>
            </ul>
          </div>
        </div>

      </div>
    </>
  )
}


